<!--血生化检查-->
<script setup>
import { computed, reactive,ref } from "vue";
import { useCrfStore } from "@/stores/crf";
import upload from "@/components/upload1.vue";
import check from "./check.vue";
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen
//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0


// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});

// 表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
</script>
<template>
  <template v-if="crfFields">
    <div style="display: flex;">

      <h2>血生化检查</h2>
      <upload :type="props.type" :data="model" name="xshjc"></upload>
      <check :period="props.type" text="血生化检查" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
    </div>

    <el-form-item label="血生化检查是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['血生化检查是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['血生化检查是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增血生化检查':'血生化检查'"  v-if="crfFields && notScreen" class="redStar">
            <el-radio-group v-if="notScreen" v-model="crfFields['是否新增血生化检查']">
              <el-radio label="是" prop="是"></el-radio>
              <el-radio label="否" prop="否"></el-radio>
            </el-radio-group>
        </el-form-item>
        
        <template v-if="crfFields['是否新增血生化检查'] == '是' || !notScreen">

            <el-form-item label="ALT（U/L）" class="redStar" :prop="itemProp(`ALT`)" :rules="crfStore.textRules(`ALT`,true)">
              <el-input v-model="crfFields['ALT']" autocomplete="off">
                <template #append>U/L</template>
              </el-input>
            </el-form-item>
            <el-form-item label="AST（U/L）" class="redStar" :prop="itemProp(`AST`)" :rules="crfStore.textRules(`AST`,true)">
              <el-input v-model="crfFields['AST']" autocomplete="off">
                <template #append>U/L</template>
              </el-input>
            </el-form-item>

            <el-form-item label="碱性磷酸酶（U/L）" class="redStar" :prop="itemProp(`碱性磷酸酶`)" :rules="crfStore.textRules(`碱性磷酸酶`,true)">
              <el-input v-model="crfFields['碱性磷酸酶']" autocomplete="off">
                <template #append>U/L</template>
              </el-input>
            </el-form-item>

            <el-form-item label="r-谷氨酰转移酶（U/L）" class="redStar" :prop="itemProp(`谷氨酰转移酶`)" :rules="crfStore.textRules(`谷氨酰转移酶`,true)">
              <el-input v-model="crfFields['谷氨酰转移酶']" autocomplete="off">
                <template #append>U/L</template>
              </el-input>
            </el-form-item>

            <el-form-item label="胆碱酯酶（U/L）" class="redStar" :prop="itemProp(`胆碱酯酶`)" :rules="crfStore.textRules(`胆碱酯酶`,true)">
              <el-input v-model="crfFields['胆碱酯酶']" autocomplete="off">
                <template #append>U/L</template>
              </el-input>
            </el-form-item>

            <el-form-item label="总胆红素(μmol/L)" class="redStar" :prop="itemProp(`总胆红素`)" :rules="crfStore.textRules(`总胆红素`,true)">
              <el-input v-model="crfFields['总胆红素']" autocomplete="off">
                <template #append>μmol/L</template>
              </el-input>
            </el-form-item>

            <el-form-item label="直接胆红素（μmol/L）" class="redStar" :prop="itemProp(`直接胆红素`)" :rules="crfStore.textRules(`直接胆红素`,true)">
              <el-input v-model="crfFields['直接胆红素']" autocomplete="off">
                <template #append>μmol/L</template>
              </el-input>
            </el-form-item>

            <!-- <el-form-item label="总蛋白（g/L）" class="redStar">
              <el-input v-model="crfFields['总蛋白']" autocomplete="off">
                <template #append>g/L</template>
              </el-input>
            </el-form-item> -->

            <el-form-item label="白蛋白（g/L）" class="redStar" :prop="itemProp(`白蛋白`)" :rules="crfStore.textRules(`白蛋白`,true)">
              <el-input v-model="crfFields['白蛋白']" autocomplete="off">
                <template #append>g/L</template>
              </el-input>
            </el-form-item>

            <el-form-item label="球蛋白（g/L）" class="redStar" :prop="itemProp(`球蛋白`)" :rules="crfStore.textRules(`球蛋白`,true)">
              <el-input v-model="crfFields['球蛋白']" autocomplete="off">
                <template #append>g/L</template>
              </el-input>
            </el-form-item>

            <el-form-item label="前白蛋白（mg/L）" class="redStar" :prop="itemProp(`前白蛋白`)" :rules="crfStore.textRules(`前白蛋白`,true)">
              <el-input v-model="crfFields['前白蛋白']" autocomplete="off">
                <template #append>mg/L</template>
              </el-input>
            </el-form-item>

            <el-form-item label="总胆汁酸（μmol/L）" class="redStar" :prop="itemProp(`总胆汁酸`)" :rules="crfStore.textRules(`总胆汁酸`,true)">
              <el-input v-model="crfFields['总胆汁酸']" autocomplete="off">
                <template #append>μmol/L</template>
              </el-input>
            </el-form-item>

            <el-form-item label="胆固醇（g）" class="not_redStar">
              <el-input v-model="crfFields['胆固醇']" autocomplete="off">
                <template #append>g</template>
              </el-input>
            </el-form-item>

            <el-form-item label="甘油三酯（mmol/L）" class="not_redStar">
              <el-input v-model="crfFields['甘油三酯']" autocomplete="off">
                <template #append>mmol/L</template>
              </el-input>
            </el-form-item>

            <el-form-item label="高密度脂蛋白（mmol/L）" class="not_redStar">
              <el-input v-model="crfFields['高密度脂蛋白']" autocomplete="off">
                <template #append>mmol/L</template>
              </el-input>
            </el-form-item>
            <el-form-item label="低密度脂蛋白（mmol/L）" class="not_redStar">
              <el-input v-model="crfFields['低密度脂蛋白']" autocomplete="off">
                <template #append>mmol/L</template>
              </el-input>
            </el-form-item>

            <el-form-item label="血肌酐（μmol/L）" class="redStar" :prop="itemProp(`血肌酐`)" :rules="crfStore.textRules(`血肌酐`,true)">
              <el-input v-model="crfFields['血肌酐']" autocomplete="off">
                <template #append>μmol/L</template>
              </el-input>
            </el-form-item>

            <el-form-item label="血糖（mmol/L）" class="redStar" :prop="itemProp(`血糖`)" :rules="crfStore.textRules(`血糖`,true)">
              <el-input v-model="crfFields['血糖']" autocomplete="off">
                <template #append>mmol/L</template>
              </el-input>
            </el-form-item>

            <el-form-item label="eGFR(ml/(min*1.73m²))" class="redStar" :prop="itemProp(`eGFR`)" :rules="crfStore.textRules(`eGFR`,true)">
              <el-input v-model="crfFields['eGFR']" autocomplete="off">
                <template #append>ml/(min*1.73m²)</template>
              </el-input>
            </el-form-item>

            <el-form-item label="血氨（μmol/L）" class="redStar" :prop="itemProp(`血氨`)" :rules="crfStore.textRules(`血氨`,true)">
              <el-input v-model="crfFields['血氨']" autocomplete="off">
                <template #append>μmol/L</template>
              </el-input>
            </el-form-item>

            <el-form-item label="铁蛋白(μg/L)" class="redStar" :prop="itemProp(`铁蛋白`)" :rules="crfStore.textRules(`铁蛋白`,true)" >
              <el-input v-model="crfFields['铁蛋白']" autocomplete="off">
                <template #append>μg/L</template>
              </el-input>
            </el-form-item>

            <el-form-item label="总铁结合力（umol/L）" class="not_redStar">
              <el-input v-model="crfFields['总铁结合力（umol/L）']" autocomplete="off">
                <template #append>umol/L</template>
              </el-input>
            </el-form-item>
            
            <el-form-item label="铜蓝蛋白（g/L）" class="redStar" :prop="itemProp(`铜蓝蛋白（g/L）`)" :rules="crfStore.textRules(`铜蓝蛋白（g/L）`,true)">
                  <el-input v-model="crfFields['铜蓝蛋白（g/L）']" autocomplete="off">
                    <template #append>g/L</template>
                  </el-input>
              </el-form-item>
        </template>
      </template>
  </template>
</template>

<style scoped>
</style>